import React from 'react'

interface ShareIconProps {
  className?: string
  stroke?: string
}

export const ShareIcon: React.FC<ShareIconProps> = ({ className = 'size-[26px]', stroke = 'white' }) => (
  <svg
    className={className}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_share)">
      <path
        d="M6.25696 6.67398L13.7121 6.50061L13.5388 13.9558"
        stroke={stroke}
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.7122 6.50088L6.28763 13.9254"
        stroke={stroke}
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_share">
        <rect width="15" height="15" fill="white" transform="translate(0 10.6066) rotate(-45)" />
      </clipPath>
    </defs>
  </svg>
)
